import { Card, Col, Row } from "react-bootstrap";
import { Loader } from "../../../components/loader";
import { useQuery } from "@tanstack/react-query";
import { getRequest } from "../../../utils/apiRequest";
import { useRecoilValue } from "recoil";
import { userState } from "../../../utils/atom";
import { formatWithDots } from "../../../utils/formatNumbers";
import { useState } from "react";
import { PaymentsTableModal } from "../modals/payment-table-modal/PaymentsTableModal";

export const PaidPaymentsInvoice = ({ startDate, endDate }) => {

    const { token } = useRecoilValue(userState);
    const [showPaymentsTableModal, setShowPaymentsTableModal] = useState(false);

    const paidPaymentsQuery = useQuery({
        queryKey: ["paid-payments-invoice", startDate, endDate],
        queryFn: () => getRequest(`/auth/statistics/paid-payments?startDate=${startDate}&endDate=${endDate}&invoice=true`, token),
        refetchOnWindowFocus: false,
    });
    const { data: paidPayments } = paidPaymentsQuery;

    return (
        <Loader isActive={paidPaymentsQuery.isLoading || paidPaymentsQuery.isFetching}>
            {paidPayments &&
                <>
                    <Card>
                        <Card.Header
                            className="hoverable-title"
                            onClick={() => setShowPaymentsTableModal(true)}
                        >
                            Verbuchte Einnahmen
                        </Card.Header>
                        <Card.Body>
                            <Row className="pb-3">
                                <Col xs={6}>
                                    Bar:
                                </Col>

                                <Col xs={6} className="text-end">
                                    {formatWithDots(paidPayments.total.cash)} €
                                </Col>
                            </Row>

                            <Row className="pt-3 pb-3 border-top border-bottom">
                                <Col xs={6}>
                                    PayPal:
                                </Col>

                                <Col xs={6} className="text-end">
                                    {formatWithDots(paidPayments.total.paypal)} €
                                </Col>
                            </Row>

                            <Row className="pt-3 pb-3 border-bottom">
                                <Col xs={6}>
                                    Überweisung:
                                </Col>

                                <Col xs={6} className="text-end">
                                    {formatWithDots(paidPayments.total.banktransfer)} €
                                </Col>
                            </Row>

                            <Row className="pt-3">
                                <Col xs={6}>
                                    Kreditkarte:
                                </Col>

                                <Col xs={6} className="text-end">
                                    {formatWithDots(paidPayments.total.card)} €
                                </Col>
                            </Row>
                        </Card.Body>
                        <Card.Footer>
                            <Row className="pt-3 pb-3">
                                <Col xs={6}>
                                    Summe:
                                </Col>
                                <Col xs={6} className="text-end">
                                    {formatWithDots(paidPayments.total.total)} €
                                </Col>
                            </Row>                           
                        </Card.Footer>
                    </Card>

                    <PaymentsTableModal 
                        title={"Verbuchte Einnahmen"}
                        showPaymentsTableModal={showPaymentsTableModal}
                        setShowPaymentsTableModal={setShowPaymentsTableModal}
                        payments={paidPayments.payments}
                        refetch={paidPaymentsQuery.refetch}
                    />
                </>
            }
        </Loader>
    );
};
